import { render, staticRenderFns } from "./SmTableCell.vue?vue&type=template&id=0215c28e&scoped=true&"
import script from "./SmTableCell.vue?vue&type=script&lang=ts&"
export * from "./SmTableCell.vue?vue&type=script&lang=ts&"
import style0 from "./SmTableCell.vue?vue&type=style&index=0&id=0215c28e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0215c28e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
